import {
  pulseItemName,
  pulseItemCtaLabel,
  pulseItemBodyMarkdown,
  parsePayload,
} from '@/modules/pulse/utils/pulseItemDisplay';

const contextClientUid = (item) => {
  const { context_type: type, context_uid: uid } = item?.context || {};
  return type === 'client' ? uid || null : null;
};

// The uid the Conversita card is keyed on. See the recommendation README, "`cardUid` is not
// `actionUid`".
export const recommendationCardUid = (item) => item?.actions?.[0]?.uid || item?.uid || null;

// The topic title is "<topicPrefix> - <context/matter name>"; the caller owns the prefix
// (and its i18n). See the README's "Topic title".
const buildRecommendationLaunch = (item, topicPrefix = '') => {
  const action = item?.actions?.[0] || {};
  const payload = parsePayload(action.payload) || {};
  const title = [topicPrefix, pulseItemName(item)].filter(Boolean).join(' - ');
  const ctaPayload = payload.cta_payload || {};
  const bodyMarkdown = pulseItemBodyMarkdown(item);
  const ctaLabel = pulseItemCtaLabel(item) || payload.cta_label || null;
  return {
    title,
    recommendation: {
      type: 'recommendation',
      ...(bodyMarkdown && { display: { body_markdown: bodyMarkdown } }),
      action: action.action || null,
      uid: recommendationCardUid(item),
      recommendation_uid: item?.uid || null,
      client_uid: payload.client_uid || ctaPayload.client_uid || contextClientUid(item),
      cta_label: ctaLabel,
    },
  };
};

export default buildRecommendationLaunch;
